import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { Textarea } from "../ui/textarea";
import { Button } from "../ui/button";
import { apiClient, getApiErrorMessage } from "../../lib/apiClient";

// Admin: add/edit a one-off Special Instruction for a single delivery (this day only).
export function SpecialInstructionDialog({ delivery, onOpenChange, onSaved }) {
  const open = Boolean(delivery);
  const [value, setValue] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (delivery) setValue(delivery.special_instruction || "");
  }, [delivery]);

  const save = async () => {
    setSaving(true);
    try {
      const { data } = await apiClient.patch(`/deliveries/${delivery.id}/special-instruction`, {
        special_instruction: value,
      });
      toast.success("Special instruction saved");
      onSaved?.(data);
      onOpenChange(false);
    } catch (error) {
      toast.error(getApiErrorMessage(error, "Could not save the special instruction."));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onOpenChange(false)}>
      <DialogContent className="max-w-md" data-testid="special-instruction-dialog">
        <DialogHeader>
          <DialogTitle>Special Instruction</DialogTitle>
        </DialogHeader>
        <p className="-mt-1 text-sm text-text-muted">
          For {delivery?.customer_name || `delivery #${delivery?.id}`} — applies to this day's delivery only. The driver sees it as a popup when they open this stop.
        </p>
        <Textarea
          value={value}
          onChange={(e) => setValue(e.target.value)}
          rows={4}
          maxLength={500}
          placeholder="e.g. Gate code 4321, call on arrival, hand to security desk."
          data-testid="special-instruction-input"
          autoFocus
        />
        <div className="flex justify-end gap-2">
          <Button variant="outline" onClick={() => onOpenChange(false)} disabled={saving} data-testid="special-instruction-cancel">Cancel</Button>
          <Button onClick={save} disabled={saving} data-testid="special-instruction-save">{saving ? "Saving…" : "Save"}</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
